export type FetchOptions = {
  url: string;
  accessToken?: string;
  body?: any;
  headers?: Record<string, string>;
};

const request = async (
  method: string,
  { url, accessToken, body, headers = {} }: FetchOptions,
) => {
  if (accessToken) {
    headers.Authorization ||= `Bearer ${accessToken}`;
  }

  headers.Accept ||= "application/json";

  const isFormData = body instanceof FormData;
  const isBinaryData = body instanceof Blob || body instanceof ArrayBuffer;
  const shouldSerializeBody = body && !isFormData && !isBinaryData;

  if (shouldSerializeBody) {
    headers["Content-Type"] ||= "application/json";
    body = JSON.stringify(body);
  }

  const response = await fetch(url, {
    method,
    headers,
    body,
  });

  const contentType = response.headers.get("Content-Type");
  const result = contentType?.includes("application/json")
    ? await response.json()
    : response;

  if (!response.ok) {
    throw new Error(
      result?.message ||
        `[native-fetch]: ${response?.status} | Something went wrong`,
    );
  }

  return result;
};

export const del = (options: FetchOptions) => request("DELETE", options);
export const get = (options: FetchOptions) => request("GET", options);
export const post = (options: FetchOptions) => request("POST", options);
export const put = (options: FetchOptions) => request("PUT", options);
export const patch = (options: FetchOptions) => request("PATCH", options);
